import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {DashboardTools} from './dashboardTools.js';

/* global customElements */
class DashboardWidget extends BaseComponent {
	
	static get properties() {
		return {
			edit: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.edit = false;
		
		var widget = this;
		setTimeout(function(){
			widget.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var widget = this;
		
		var backColor = widget.config.titleColor || '#253746';
		var textColor = widget.config.titleTextColor || 'white';
		
		var innerCSS = ElementUtil.create({
			tag: 'style',
			slot: 'footer',
			innerHTML: `					
		
			`
		});	
		
		widget.header = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			style: 'padding: 5px; height: 25px; background-color: ' + backColor + '; color: ' + textColor + ';',
			children: [
				{
					tag: 'div',
					style: 'font-size: 18px;',
					innerHTML: widget.config.name
				},
				{
					tag: 'span',
					style: 'float: right; margin-top: -27px;',
					children: [
						{
							tag: 'vaadin-button',
							itemId: 'shiftLeft',
							theme: 'icon small',
							style: 'color: ' + textColor + ';',
							'class': 'hide',
							title: 'Shift Left',
							children: [
								{
									tag: 'vaadin-icon',
									icon: 'vaadin:chevron-circle-left'
								}
							],						
							listeners: {
								click: function() {
									actionShift(false);
								}
							}
						},
						{
							tag: 'vaadin-button',
							itemId: 'shiftRight',							
							theme: 'icon small',
							style: 'color: ' + textColor + ';',
							'class': 'hide',
							title: 'Shift Right',
							children: [
								{
									tag: 'vaadin-icon',
									icon: 'vaadin:chevron-circle-right'
								}
							],
							listeners: {
								click: function() {
									actionShift(true);
								}
							}
						},
						{
							tag: 'vaadin-button',
							itemId: 'config',
							theme: 'icon small',
							style: 'color: ' + textColor + ';',
							'class': 'hide',
							title: 'Configure',
							children: [
								{
									tag: 'vaadin-icon',
									icon: 'vaadin:cog'
								}
							],
							listeners: {
								click: function() {
									actionConfig();
								}
							}
						},
						{
							tag: 'vaadin-button',
							itemId: 'delete',	
							theme: 'icon small error primary',							
							'class': 'hide',
							title: 'Remove',
							children: [
								{
									tag: 'vaadin-icon',
									icon: 'vaadin:close'
								}
							],
							listeners: {
								click: function() {
									actionDelete();
								}
							}
						}
					]
				}
			]
		});
		
		//container
		
		var widgetFullConfig = Object.assign(
				{}, 
				{
					tag: widget.config.wigdetId,
					'widgetmode': true,
					slot: 'primary'
				}, 
				(widget.config.properties || {})
		);
		
		var widgetContainer = ElementUtil.create(widgetFullConfig);
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				widget.header,
				widgetContainer,
				innerCSS
			]
		});		
		widget.append(flexLayout);		
		
		var actionShift = function(right) {
			var customEvent = new CustomEvent('shift', { detail: { shiftRight: right} });
			widget.dispatchEvent(customEvent);
		};
		
		var actionConfig = function() {
			var customEvent = new CustomEvent('config', { detail: { config: widget.config} });
			widget.dispatchEvent(customEvent);			
		};
		
		var actionDelete = function() {
			var customEvent = new CustomEvent('remove', { detail: { config: widget.config} });
			widget.dispatchEvent(customEvent);						
		};
		
	}
	
	editMode() {
		var widget = this;		
		
		ElementUtil.query(widget.header, 'shiftLeft').classList.remove('hide');
		ElementUtil.query(widget.header, 'shiftRight').classList.remove('hide');
		ElementUtil.query(widget.header, 'config').classList.remove('hide');
		ElementUtil.query(widget.header, 'delete').classList.remove('hide');
		
		if (widget.firstWidget){
			ElementUtil.query(widget.header, 'shiftLeft').classList.add('hide');
		} 
		
		if (widget.lastWidget) {
			ElementUtil.query(widget.header, 'shiftRight').classList.add('hide');
		}
		
	}
	
	normalMode() {
		var widget = this;	
		
		ElementUtil.query(widget.header, 'shiftLeft').classList.add('hide');
		ElementUtil.query(widget.header, 'shiftRight').classList.add('hide');
		ElementUtil.query(widget.header, 'config').classList.add('hide');
		ElementUtil.query(widget.header, 'delete').classList.add('hide');		
	}

};
customElements.define('dl-dashboard-widget', DashboardWidget);